module.exports = __webpack_public_path__ + "img/clip_image063.ed083139.png";